export const dateModifiedMessage = (modifyDateTime) => {
  const currentDateTime = new Date();
  const parsedCurrentDateTime = Date.parse(currentDateTime);
  const currentDate = new Date(currentDateTime.toLocaleDateString('en-US'));

  const lastModifiedDateTime = new Date(modifyDateTime);
  const lastModifiedLocalDateTime = new Date(lastModifiedDateTime.toLocaleString('en-US'));
  const lastModifiedDate = new Date(lastModifiedDateTime.toLocaleDateString('en-US'));
  const parsedLastModifiedDateTime = Date.parse(lastModifiedLocalDateTime);
  const daysSinceLastUpdate = Math.floor((Math.abs(lastModifiedDate - currentDate)) / (1000 * 60 * 60 * 24));
  const secondsSinceLastUpdate = Math.floor((parsedCurrentDateTime - parsedLastModifiedDateTime) / 1000);
  let lastModifiedMessage = '';

  if (daysSinceLastUpdate < 1) {
    if (secondsSinceLastUpdate <= 60) {
      lastModifiedMessage = 'Just now';
    }
    if (secondsSinceLastUpdate > 60 && secondsSinceLastUpdate < 3600) {
      const minutes = Math.floor(secondsSinceLastUpdate / 60);
      lastModifiedMessage = minutes === 1 ? `${minutes} minute ago` : `${minutes} minutes ago`;
    }
    if (secondsSinceLastUpdate >= 3600) {
      const hours = Math.floor(secondsSinceLastUpdate / 3600);
      lastModifiedMessage = hours === 1 ? `${hours} hour ago` : `${hours} hours ago`;
    }
  }
  if (daysSinceLastUpdate === 1) {
    lastModifiedMessage = 'Yesterday';
  }
  if (daysSinceLastUpdate > 1 && daysSinceLastUpdate <= 6) {
    lastModifiedMessage = `${daysSinceLastUpdate} days ago`;
  }
  if (daysSinceLastUpdate > 6) {
    lastModifiedMessage = lastModifiedDateTime.toLocaleDateString();
  }
  return lastModifiedMessage;
};

export const triggerAnalytics = (event, payload) => {
  LIFE_CYCLE_EVENT_BUS.trigger(event, payload);
};